import {
  AsyncSelect,
  DropdownIndicatorProps,
  Input,
  chakraComponents,
  FiMapPin
} from "@/storybook-components";
import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";

import { SuburbQuestionProps } from "../types";

export const SuburbsQuestion = (props: SuburbQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    isClearable = true,
    cacheOptions = true,
    size,
    contentClassName,
    placeholder,
    isDisabled,
    changeEventHandler,
    answerProps,
    menuPlacement = "auto",
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps,
    shouldFetchAsyncData,
    asyncHandler,
    onMenuClose,
    onMenuOpen,
    answerAriaLabel
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionId,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        {shouldFetchAsyncData ? (
          <AsyncSelect
            id={questionId}
            className={contentClassName}
            size={size}
            isClearable={isClearable}
            cacheOptions={cacheOptions}
            value={answer}
            menuPlacement={menuPlacement}
            isDisabled={isDisabled}
            onChange={changeEventHandler}
            loadOptions={asyncHandler}
            placeholder={placeholder}
            aria-label={answerAriaLabel}
            onMenuClose={onMenuClose}
            onMenuOpen={onMenuOpen}
            components={{
              DropdownIndicator: (props: DropdownIndicatorProps) => (
                <chakraComponents.DropdownIndicator {...props}>
                  <FiMapPin />
                </chakraComponents.DropdownIndicator>
              )
            }}
            {...answerProps}
          />
        ) : (
          <Input
            id={questionId}
            className={contentClassName}
            type="text"
            value={answer}
            onChange={changeEventHandler}
            isDisabled={isDisabled}
            {...answerProps}
            aria-label={answerAriaLabel}
            size={size}
          />
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
